<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20" v-if="false">
            <el-form-item label="平台ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入平台ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="用户姓名">
              <el-input v-model="queryParams.username" @change="search" placeholder="请输入用户姓名"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20" v-if="false">
            <el-form-item label="选择性别">
              <el-select v-model="queryParams.sex" placeholder="请选择性别" @change="search" clearable style="width: 100%;">
                <el-option label="保密" :value="0"></el-option>
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
		  <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
		    <el-form-item label="人才类别">
		      <el-select v-model="queryParams.fw_types" placeholder="请选择人才类别" @change="search" clearable style="width: 100%;">
		        <el-option :label="item.name" :value="item.id" v-for="item in fwTypes" v-if="item.type == 1"></el-option>
		      </el-select>
		    </el-form-item>
		  </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20" v-if="group_id <= 2">
            <el-form-item label="手机号">
              <el-input v-model="queryParams.phone" @change="search" placeholder="请输入手机号"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="工作单位">
              <el-input v-model="queryParams.employers" @change="search" placeholder="请输入工作单位"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20" v-if="group_id <= 2">
            <el-form-item label="服务方式">
              <el-select v-model="queryParams.fw_methond" placeholder="请选择服务方式" @change="search" clearable style="width: 100%;">
		        <el-option :label="item.name" :value="item.id" v-for="item in fwTypes" v-if="item.type == 2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="服务需求">
              <el-select v-model="queryParams.fw_con" placeholder="请选择服务需求" @change="search" clearable style="width: 100%;">
		        <el-option :label="item.name" :value="item.id" v-for="item in fwTypes" v-if="item.type == 3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20" v-if="group_id <= 2">
            <el-form-item label="审核状态">
              <el-select v-model="queryParams.is_sh" placeholder="请选择审核状态" @change="search" clearable style="width: 100%;">
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="审核通过" :value="1"></el-option>
                <el-option label="审核驳回" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20" v-if="group_id <= 2">
            <el-form-item label="处理部门">
              <el-select v-model="queryParams.deal_group" placeholder="请选择处理部门" @change="search" clearable filterable style="width: 100%;">
                <el-option :label="item.name" :value="item.id" v-for="item in groups"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-download" @click="download">导出</el-button>
      </div>
      <MyTable
        ref="myTableRef"
        :table-data="tableData"
        :columns="columns"
        :loading="loading"

        :total="total"
        :page-no="queryParams.pageNo"
        :page-size="queryParams.pageSize"
        @pagination-change="paginationChange"
      >
        <template #fw_contents="{ scope }">
          <el-tooltip :disabled="!scope.row.fw_contents || scope.row.fw_contents.length <= 20" :content="scope.row.fw_contents" placement="top">
            <span>{{ scope.row.fw_contents }}</span>
          </el-tooltip>
        </template>
        <template #sh_files="{ scope }">
          <el-button v-if="scope.row.sh_files && scope.row.sh_files.length > 0" type="text" @click="showFiles(scope.row.sh_files, '审核附件')">查看附件({{ scope.row.sh_files.length }})</el-button>
          <span v-else>-</span>
        </template>
        <template #deal_files="{ scope }">
          <el-button v-if="scope.row.deal_files && scope.row.deal_files.length > 0" type="text" @click="showDealFiles(scope.row.deal_files)">查看附件({{ scope.row.files_tot || 0 }})</el-button>
          <span v-else>-</span>
        </template>
        <template #deal_comments="{ scope }">
          <div v-html="scope.row.deal_comments">
          </div>
        </template>
        <template #operation>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template slot-scope="scope">
			  <div v-if="group_id <= 2">
				  <el-button type="text" size="medium" class="mr10" @click="handleEdit(scope.row)" v-if="group_id <= 2 && scope.row.is_sh == 0">审核</el-button>
				  <el-button type="text" size="medium" class="mr10" disabled v-else>已审核</el-button>
				  <el-popconfirm
				    confirm-button-text='确定'
				    cancel-button-text='取消'
				    icon="el-icon-info"
				    icon-color="red"
				    title="确定要删除吗？"
				    @confirm="handleDel(scope.row.id)"
				  				v-if="false"
				  >
				    <el-button slot="reference" type="text" class="PUB_BTN_RED">删除</el-button>
				  </el-popconfirm>
			  </div>
			  <div v-else>
          <el-popconfirm
				    confirm-button-text='确定'
				    cancel-button-text='取消'
				    icon="el-icon-info"
				    icon-color="red"
				    title="确定要接单吗？"
				    @confirm="handleJd(scope.row)"
            v-if="group_id > 2 && scope.row.is_banjie == 0"
				  >
				    <el-button slot="reference" type="text" class="PUB_BTN_RED">接单</el-button>
				  </el-popconfirm>
				  <el-button type="text" size="medium" class="mr10" @click="handleEdit(scope.row)" v-else-if="group_id > 2 && scope.row.is_banjie == 1">办结</el-button>
				  <el-button type="text" size="medium" class="mr10" disabled v-else>已办结</el-button>
			  </div>
            </template>
          </el-table-column>
        </template>
      </MyTable>
      <edit 
        v-if="dialogVisible" 
        :editID="editID"
        :dialogVisible="dialogVisible" 
        @NoneDlog="NoneDlog" 
        @AddOk="AddOk"
      >
      </edit>

      <!-- 审核附件弹窗 -->
      <el-dialog :title="filesDialogTitle" :visible.sync="filesDialogVisible" width="700px" class="files-dialog" :close-on-click-modal="false">
        <div class="files-container">
          <div v-for="(file, index) in currentFiles" :key="index" class="file-item-card">
            <div class="file-icon-wrapper">
              <i class="el-icon-document"></i>
            </div>
            <div class="file-content">
              <div class="file-name" :title="file.name">{{ file.name }}</div>
              <div class="file-meta">
                <span class="file-index">附件 {{ index + 1 }}</span>
              </div>
            </div>
            <div class="file-actions">
              <a :href="getFileUrl(file.url)" target="_blank" class="action-btn">
                <i class="el-icon-view"></i>
                <span>预览</span>
              </a>
            </div>
          </div>
          <div v-if="!currentFiles || currentFiles.length === 0" class="empty-state">
            <div class="empty-icon"><i class="el-icon-folder-opened"></i></div>
            <p class="empty-text">暂无附件</p>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <span class="file-count" v-if="currentFiles && currentFiles.length > 0">共 {{ currentFiles.length }} 个附件</span>
          <el-button @click="filesDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 职能部门附件弹窗 -->
      <el-dialog title="职能部门附件" :visible.sync="dealFilesDialogVisible" width="700px" class="files-dialog" :close-on-click-modal="false">
        <div class="files-container">
          <div v-for="(dept, di) in currentDealFiles" :key="di" class="dept-block">
            <div class="dept-title" style="margin-bottom: 12px;">
              <i class="el-icon-office-building"></i>
              {{ dept.name }}
              <span class="dept-count">{{ dept.files && dept.files.length || 0 }} 个附件</span>
            </div>
            <div v-if="dept.files && dept.files.length > 0">
              <div v-for="(file, fi) in dept.files" :key="fi" class="file-item-card">
                <div class="file-icon-wrapper">
                  <i class="el-icon-document"></i>
                </div>
                <div class="file-content">
                  <div class="file-name" :title="file.name">{{ file.name }}</div>
                  <div class="file-meta">
                    <span class="file-index">附件 {{ fi + 1 }}</span>
                  </div>
                </div>
                <div class="file-actions">
                  <a :href="getFileUrl(file.url)" target="_blank" class="action-btn">
                    <i class="el-icon-view"></i>
                    <span>预览</span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else class="dept-empty">暂无附件</div>
          </div>
          <div v-if="!currentDealFiles || currentDealFiles.length === 0" class="empty-state">
            <div class="empty-icon"><i class="el-icon-folder-opened"></i></div>
            <p class="empty-text">暂无附件</p>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <span class="file-count" v-if="currentDealFiles && currentDealFiles.length > 0">共 {{ currentDealFiles.length }} 个部门</span>
          <el-button @click="dealFilesDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

    </el-card>
  </div>
</template>

<script>
import {apis} from "@/api/infos";
import {administratorsAPI} from "@/api/account/administrators";
import {processErrors} from "@/utils/errorHandler";
import { Session } from '@/utils/storage';
const api = apis();
const adminAPI = administratorsAPI();
export default {
  components: {
    Edit:()=>import('./sh.vue')
  },
  data() {
    return {
      group_id: 999,
      columns: [],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
		id: '',
		username: '',
		sex: '',
		fw_types: '',
		phone: '',
		employers: '',
		fw_methond: '',
		fw_con: '',
		is_sh: '',
		deal_group: ''
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },
	  fwTypes: [],
	  groups: [],

      tableData: [],
      editID: "",
      total: 0,
      dialogVisible: false,
      loading: false,
	  group_id: 0,
      filesDialogVisible: false,
      filesDialogTitle: '',
      currentFiles: [],
      dealFilesDialogVisible: false,
      currentDealFiles: []
    };
  },
  created() {
    this.group_id = Session.get('roleId')
    if(this.group_id <= 2){
      this.columns = [
        { label: '姓名', prop: 'username', fixed: true },
        { label: '性别', prop: 'sex_text' },
        { label: '人才类别', prop: 'fw_types_text', width: '120' },
        { label: '手机号', prop: 'phone', width: '120' },
        { label: '工作单位', prop: 'employers', width: '120' },
        { label: '职务', prop: 'positions', width: '120' },
        { label: '服务需求', prop: 'fw_con_text' },
        { label: '服务方式', prop: 'fw_methond_text', width: '120' },
        { label: '需求内容', prop: 'fw_contents', width: '250', slotKey: 'fw_contents' },
        { label: '审核状态', prop: 'is_sh_text' },
        { label: '审核时间', prop: 'sh_time', width: '170' },
        { label: '审核意见', prop: 'sh_comments' },
        { label: '审核附件', prop: 'sh_files', slotKey: 'sh_files', width: '120' },
        { label: '处理部门', prop: 'deal_group_text', width: '170' },
        { label: '处理意见', prop: 'deal_comments', slotKey: 'deal_comments', align: 'left', width: '250' },
        { label: '职能部门附件', prop: 'deal_files', slotKey: 'deal_files', width: '130' }
      ]
    }else{
      this.columns = [
        { label: '姓名', prop: 'username', fixed: true },
        { label: '性别', prop: 'sex_text' },
        { label: '人才类别', prop: 'fw_types_text', width: '120' },
        { label: '手机号', prop: 'phone', width: '120' },
        { label: '工作单位', prop: 'employers', width: '120' },
        { label: '职务', prop: 'positions', width: '120' },
        { label: '服务需求', prop: 'fw_con_text' },
        { label: '服务方式', prop: 'fw_methond_text', width: '120' },
        { label: '需求内容', prop: 'fw_contents', width: '250', slotKey: 'fw_contents' },
        { label: '审核时间', prop: 'sh_time', width: '170' },
        { label: '审核意见', prop: 'sh_comments' },
        { label: '审核附件', prop: 'sh_files', slotKey: 'sh_files', width: '120' },
        // { label: '职能部门附件', prop: 'deal_files', slotKey: 'deal_files', width: '130' }
      ]
    }
    this.getOthers();
    this.getList();
    this.group_id = Session.get("roleId");
  },
  methods: {
    getFileUrl(url) {
      if (!url) return '';
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      return process.env.VUE_APP_BASE_API + url;
    },
    showFiles(files, title) {
      this.currentFiles = files || [];
      this.filesDialogTitle = title || '附件';
      this.filesDialogVisible = true;
    },
    showDealFiles(dealFiles) {
      this.currentDealFiles = dealFiles || [];
      this.dealFilesDialogVisible = true;
    },
    objectToQueryString(obj) {
      const params = new URLSearchParams();
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key]);
        }
      }
      return params.toString();
    },
    download(type){
      let that = this;
      this.$confirm('确认导出所有数据吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = that.queryParams;
        params.token = Session.get('token')
        const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/rc/feedback/export';
        window.location.href = baseExportUrl + '?' + this.objectToQueryString(params)
      }).catch(() => { })
    },
	getOthers(){
		api.ApiCategorySelect().then(res => {
		    this.fwTypes = res.data
		})
		adminAPI.roleList({child: 1}).then(res => {
			this.groups = res.data.data
		})
	},
    getList(type) {
      this.loading = true
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      api.ApiInfoList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    paginationChange({pageNo, pageSize}){
      this.queryParams.pageNo = pageNo
      this.queryParams.pageSize = pageSize
      this.getList('changePage')
    },
    search() {
      this.getList()
    },
    handleDel(id){
      api.ApiInfoDel({id}).then(res=>{
        if (res.code == 0) { 
          this.$message({ message: '删除成功', type: 'success' });
          this.getList('changePage')
        }
      })
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
		id: '',
		username: '',
		sex: '',
		fw_types: '',
		phone: '',
		employers: '',
		fw_methond: '',
		fw_con: '',
		is_sh: '',
		deal_group: ''
      }
      this.getList()
    },
    NoneDlog() {
      this.dialogVisible = false
    },
    AddOk() {
      this.editID = ""
      this.dialogVisible = false
      this.getList()
    },
    handleEdit(row) {
      this.editID = row.id
      this.dialogVisible = true
    },
    handleJd(row){
      let id = row.id;
      api.ApiInfoJiedan({id}).then(res=>{
        if (res.code == 0) { 
          this.$message({ message: '接单成功', type: 'success' });
          this.getList('changePage')
        }else{
          this.$message({ message: res.msg || '接单失败', type: 'success' });
        }
      })
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {
    padding: 0 !important;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

::v-deep .el-radio input[aria-hidden="true"] {
  display: none !important;
}

.files-dialog {
  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px;
    
    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }
    
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 20px;
      &:hover { color: #f0f0f0; }
    }
  }
  
  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f8f9fa;
  }
  
  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e8e8e8;
  }

  .files-container {
    max-height: 500px;
    overflow-y: auto;
    
    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
      &:hover { background: #a8a8a8; }
    }
  }

  .dept-block {
    margin-bottom: 20px;

    .dept-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 15px;
      font-weight: 600;
      color: #2c3e50;
      padding: 10px 14px;
      background: linear-gradient(135deg, rgba(102,126,234,0.1) 0%, rgba(118,75,162,0.1) 100%);
      border-left: 4px solid #667eea;
      border-radius: 0 6px 6px 0;
      margin-bottom: 10px;

      i { color: #667eea; font-size: 16px; }

      .dept-count {
        margin-left: auto;
        font-size: 12px;
        color: #8492a6;
        font-weight: 400;
        background: #f0f2f5;
        padding: 2px 8px;
        border-radius: 10px;
      }
    }

    .dept-empty {
      text-align: center;
      color: #c0c4cc;
      font-size: 13px;
      padding: 16px 0;
    }
  }

  .file-item-card {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    margin-bottom: 12px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid transparent;

    &:hover {
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
      border-color: #667eea;
      transform: translateY(-2px);
    }

    .file-icon-wrapper {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 8px;
      margin-right: 16px;
      flex-shrink: 0;
      i { font-size: 24px; color: #fff; }
    }

    .file-content {
      flex: 1;
      min-width: 0;

      .file-name {
        font-size: 15px;
        color: #2c3e50;
        font-weight: 500;
        margin-bottom: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.4;
      }

      .file-meta {
        display: flex;
        align-items: center;
        gap: 12px;

        .file-index {
          font-size: 12px;
          color: #8492a6;
          padding: 2px 8px;
          background: #f0f2f5;
          border-radius: 4px;
        }
      }
    }

    .file-actions {
      display: flex;
      gap: 8px;
      margin-left: 16px;

      .action-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 8px 16px;
        background: #f8f9fa;
        border: 1px solid #e8e8e8;
        border-radius: 6px;
        color: #667eea;
        font-size: 13px;
        text-decoration: none;
        transition: all 0.2s;
        cursor: pointer;
        i { font-size: 14px; }

        &:hover {
          background: #667eea;
          border-color: #667eea;
          color: #fff;
          transform: translateY(-1px);
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 60px 0;

    .empty-icon {
      width: 80px;
      height: 80px;
      margin: 0 auto 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      i { font-size: 40px; color: #fff; }
    }

    .empty-text {
      margin: 0;
      font-size: 15px;
      color: #8492a6;
    }
  }
  
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .file-count {
      font-size: 14px;
      color: #667eea;
      font-weight: 500;
    }
  }
}
</style>
